import { ConfigDefinitionDictionary } from './config-definition.models';
import { setDefaultLogLevelToSilent } from '../dev-tools/log-level';
import { CookieManager } from '../browser-utilities/cookie-manager';
import { PollingManager } from '../polling-manager/polling-manager';

export const configDefinition: ConfigDefinitionDictionary = {
  apiKey: {
    allowedTypes: ['string'],
    default: undefined
  },
  apiUrl: {
    allowedTypes: ['string'],
    default: 'https://trk-api.crossengage.io/api/v1'
  },
  rootDomain: {
    allowedTypes: ['string', 'boolean'],
    default: false
  },
  silentLogs: {
    allowedTypes: ['boolean'],
    default: false,
    onSet: setDefaultLogLevelToSilent
  },
  trackingOptIn: {
    allowedTypes: ['boolean'],
    default: CookieManager.getCookie('ce.tracking-opt-in') === 'true' ? true : false,
    onSet: (value: boolean) => {
      value ? CookieManager.setCookie('ce.tracking-opt-in', 'true') : CookieManager.deleteCookie('ce.tracking-opt-in');
    }
  },
  globalEventProperties: {
    allowedTypes: ['object'],
    default: {}
  },
  forceEnablePolling: {
    allowedTypes: ['boolean'],
    default: false,
    onSet: (value: boolean) => {
      if (value) {
        PollingManager.startPolling();
      }
    }
  },
  globalUserId: {
    allowedTypes: ['string', 'null'],
    default: CookieManager.getCookie('ce.guid') || null,
    onSet: (value: string | null) => {
      value !== null ? CookieManager.setCookie('ce.guid', value) : CookieManager.deleteCookie('ce.guid');
    }
  },
  sessionId: {
    allowedTypes: ['string', 'null'],
    default:  CookieManager.getCookie('ce.sid') || null,
    onSet: (value: string | null) => {
      value !== null ? CookieManager.setCookie('ce.sid', value) : CookieManager.deleteCookie('ce.sid');
    }
  }
}
